(ns ui.components.grid.view
  (:require
   [reagent.core :as r]
   [react :as react]
   ["ag-grid-react" :as ag-grid-react]
   ["ag-grid-enterprise"]
   ["ag-grid-community" :refer [themeQuartz]]
   [oops.core :as oops]))

(defn adapt
  ([cls-name]
   (r/adapt-react-class (aget ag-grid-react cls-name)))
  ([parent-cls cls-name]
   (r/adapt-react-class (aget (aget ag-grid-react parent-cls) cls-name))))

(defn adapt-enterprise
  ([cls-name]
   (r/adapt-react-class (aget ag-grid-react cls-name)))
  ([parent-cls cls-name]
   (r/adapt-react-class (aget (aget ag-grid-react parent-cls) cls-name))))

(def default-theme-params
  {:accentColor "var(--primary-regular)"
   :headerFontWeight "600"
   :fontFamily [{:googleFont "Muli"} "sans-serif"]})

(def theme-quartz (oops/ocall themeQuartz "withParams" (clj->js default-theme-params)))

(def ag-grid (adapt "AgGridReact"))
(def ag-grid-enterprise (adapt-enterprise "AgGridReact"))

(defn ag-grid-js
  "Direct AgGridReact mount with explicit JS props.
   Use this when wrapper prop conversion causes issues with callback names."
  [props]
  (r/create-element (aget ag-grid-react "AgGridReact")
                    (clj->js props)))

(defn top-offset-sentinel-inner
  [{:keys [set-top-offset]}]
  (let [ref* (atom nil)
        update-top-offset #(when-let [el @ref*]
                             (let [rect (oops/ocall el "getBoundingClientRect")
                                   top-offset (+ (oops/oget rect "top")
                                                 (oops/oget js/window "scrollY"))]
                               (set-top-offset top-offset)))]
    (fn []
      (react/useLayoutEffect
       (fn []
         (update-top-offset)
         (constantly true))
       (clj->js []))

      (react/useEffect
       (fn []
         (oops/ocall js/window "addEventListener" "resize" update-top-offset)
         (fn []
           (oops/ocall js/window "removeEventListener" "resize" update-top-offset)))
       (clj->js []))

      [:div {:ref #(reset! ref* %)}])))

(defn top-offset-sentinel
  [props]
  [:f> top-offset-sentinel-inner props])
